module.exports = __webpack_public_path__ + "img/3.2.afc5dd5d.jpg";